import { makeAPIRequest } from './surveyService';

const BASE = '/evaluaciones-pendientes';

export const getEvaluacionesPendientes = (filters = {}) =>
  makeAPIRequest(BASE, 'get', filters);

export const createEvaluacionesPendientes = (rows) =>
  makeAPIRequest(BASE, 'post', {}, { items: rows });

export const updateEvaluacionPendiente = (id, data) =>
  makeAPIRequest(`${BASE}/${id}`, 'put', {}, data);

export const deleteEvaluacionPendiente = (id) =>
  makeAPIRequest(`${BASE}/${id}`, 'delete');

export const buildRow = () => ({
  asignatura:        '',
  nombre_evaluacion: '',
  fecha_oficial:     '',
  fecha_realizada:   '',
});
